import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title = 'Advocacia Trabalhista Especializada | Paulo Ferreira & Maike Ramos',
  description = 'Escritório de advocacia especializado em direito do trabalho e previdenciário em Sorocaba. Atendemos casos de acidente de trabalho, horas extras, assédio moral e outros direitos trabalhistas.',
  keywords = 'advocacia trabalhista, advogado trabalhista, direito do trabalho, advogado sorocaba, direito previdenciário, acidente de trabalho',
  image = '/assets/Marca d_água/PNG/MARCA D_ÁGUA.png', 
  url = 'https://seudominio.com.br'
}) => {
  return (
    <Helmet>
      {/* Meta tags básicas */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Meta tags Open Graph para compartilhamento em redes sociais */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image.startsWith('http') ? image : `${url}${image}`} />
      
      {/* Meta tags para Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image.startsWith('http') ? image : `${url}${image}`} />
      
      {/* Dados estruturados para escritório de advocacia (Schema.org) */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "LegalService",
            "name": "Paulo Ferreira & Maike Ramos Advocacia",
            "image": "${url}/assets/Marca d_água/PNG/MARCA D_ÁGUA.png",
            "description": "${description}",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "R. Santa Rosália, 276",
              "addressLocality": "Sorocaba",
              "addressRegion": "SP",
              "postalCode": "18095-040",
              "addressCountry": "BR"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": -23.493394375077266,
              "longitude": -47.45657385346649
            },
            "url": "${url}",
            "telephone": "+5515997152102",
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday"
              ],
              "opens": "08:00",
              "closes": "18:00"
            },
            "priceRange": "$$"
          }
        `}
      </script>
    </Helmet>
  );
};

export default SEO;